module.exports = __webpack_public_path__ + "static/media/React-E-School.912003ec.png";